import { request } from '@mairistem/tools';
import type ImputationsApcp from '../../interfaces/outil/infoImputationsApcp';

const url = '/api/finances/simulation/apcp/projets';

export const getInfoImputationsApcp = (params: URLSearchParams) =>
	request.get<any, ImputationsApcp[]>(
		`${url}/infoImputationsApcp?${params.toString()}`,
	);
